import { Injectable } from '@angular/core';
import { BaseServiceService } from '@core/graph-ql/base-service/base-service.service';
import { GraphFunctionsTypesInputs } from '@core/graph-ql/graph-functions/graph-functions-types-inputs';
import { QueryFull } from '@core/models/graph-models';


@Injectable({
  providedIn: 'root',
})
export class AccInfoService extends GraphFunctionsTypesInputs {
  constructor(private baseServiceService: BaseServiceService) {
    super();
  }

  getBuyer() {
    const input = {} as QueryFull;
    input.func = this.FUNC_BUYER;
    input.return = this.BUYER;
    return this.baseServiceService.generalQuery(input);
  }

  validateUserByLogin(variables: any) {
    const input = {} as QueryFull;
    input.func = this.FUNC_SIGNIN;
    input.variable = this.INPUT_SIGNIN;
    input.type = this.TYPE_SIGNIN;
    input.variables = variables;
    input.return = this.TOKEN;
    return this.baseServiceService.generalMutationFull(input);
  }

  updateBuyer(variables: any) {
    const input = {} as QueryFull;
    input.func = this.FUNC_UPDATE_BUYER;
    input.variable = this.INPUT_UPDATE_BUYER;
    input.type = this.TYPE_UPDATE_BUYER;
    input.variables = variables;
    input.return = this.BUYER;
    return this.baseServiceService.generalMutationFull(input);
  }

  updatePassword(variables: any) {
    const input = {} as QueryFull;
    input.func = this.FUNC_CHANGE_PASS;
    input.variable = this.INPUT_CHANGE_PASS;
    input.type = this.TYPE_CHANGE_PASS;
    input.variables = variables;
    input.return = this.MESSAGE;
    return this.baseServiceService.generalMutationFull(input);
  }

  changeEmailRequest(variables: any) {
    const input = {} as QueryFull;
    input.func = this.FUNC_RESET_EMAIL;
    input.variable = this.INPUT_RESET_EMAIL;
    input.type = this.TYPE_RESET_EMAIL;
    input.variables = variables;
    input.return = this.MESSAGE;
    return this.baseServiceService.generalMutationFull(input);
  }
}
